const {Methodius} = require('methodius');
// const { generateNgramsFromSamples, sampleMap } = require('.
const { LanguageNav, TableSet, FrequencyTable } = require('./templates');




// convert that map to ngram objects
// const ngrams = generateNgramsFromSamples(sampleMap, NGrammer);
// add it to the page
// makeTableSets(ngrams, document.querySelector('.js-tables'));
// makeNav(ngrams, document.querySelector('.js-nav'));
window.Methodius = Methodius;
